import React from 'react'

import { dashifyString } from '../../lib/helpers'

import { makeStyles } from '@material-ui/core/styles'
import MUIExpansionPanelSummary from '@material-ui/core/AccordionSummary'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import Typography from '@material-ui/core/Typography'
import CustomSVG from '../../components/custom-svg'
import SvgIcon from '@material-ui/core/SvgIcon'

import { ReactComponent as TargetIcon } from '../../assets/images/sanctions-blue.svg'

const localStyles = {
  subtitleItemIconSize: '14px'
}

const styles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0.5, 1.75),
    [theme.breakpoints.up('md')]: {
      minHeight: '62px'
    },

    '&.Mui-expanded': {
      minHeight: 'auto',
      [theme.breakpoints.up('md')]: {
        minHeight: '62px'
      }
    },

    '& .MuiAccordionSummary-expandIcon': {
      color: theme.palette.primary.main
    },

    '& .MuiAccordionSummary-content': {
      display: 'flex',
      alignItems: 'center',
      margin: '6px 0'
    }
  },

  summaryIcon: {
    alignSelf: 'flex-start',
    justifyContent: 'center',
    display: 'flex',
    marginRight: theme.spacing(1),
    background: theme.palette.secondary.light,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.75),
    width: '35px',
    height: '35px',
    color: theme.palette.primary.main,

    '& svg': {
      maxWidth: '23px',
      maxHeight: '23px',

      '& path': {
        fill: theme.palette.primary.main
      }
    }
  },

  summaryIconNoBg: {
    position: 'relative',
    top: '2px',
    marginRight: '6px',
    '& svg': {
      maxWidth: '18px',
      maxHeight: '18px'
    }
  },

  wrapper: {},

  title: {},

  subtitle: {
    color: theme.palette.grey[500],
    display: 'block',
    marginTop: '-3px'
  },

  nested: {
    '& + .MuiCollapse-container': {
      '& .MuiAccordion-root': {
        '&.Mui-expanded': {
          margin: '0',

          '&:before': {
            opacity: '1'
          },

          '& .MuiDivider-root': {
            opacity: '0'
          }
        },
        '& .MuiAccordionSummary-root': {
          '& .MuiAccordionSummary-content': {
            '& .MuiTypography-h4': {
              fontSize: theme.typography.h5.fontSize,
              fontWeight: theme.typography.h5.fontWeight
            },
            '& .MuiTypography-caption': {
              marginTop: '0'
            }
          },
          '& .MuiAccordionSummary-root': {
            padding: '0'
          }
        }
      }
    }
  },

  subtitleItems: {
    display: 'flex',
    marginTop: '3px',
    color: theme.palette.grey[500]
  },

  subtitleItem: {
    display: 'flex',
    marginRight: '6px'
  },

  subtitleItemIcon: {
    width: localStyles.subtitleItemIconSize,
    height: localStyles.subtitleItemIconSize,
    marginRight: '2px',
    fill: 'currentColor',

    '& svg': {
      width: localStyles.subtitleItemIconSize,
      height: localStyles.subtitleItemIconSize
    }
  },
  subtitleItemIconActive: {
    color: theme.palette.primary.main
  },
  subtitleItemText: {
    color: theme.palette.grey[500]
  },
  subtitleItemTextActive: {
    color: theme.palette.primary.main
  },
  expandIcon: {
    padding: '12px 10px'
  }
}))

export default function ExpansionPanelSummary(props) {
  const classes = styles(props)
  let icon = props.icon ? <CustomSVG content={props.icon.iconSource} /> : null

  // Fallback icon for target types when no icon is set
  if (props.type === 'target' && !icon) {
    icon = <SvgIcon component={TargetIcon} viewBox="0 0 18 18" />
  }

  return (
    <>
      <MUIExpansionPanelSummary
        expandIcon={props.expanded ? <RemoveIcon /> : <AddIcon />}
        aria-controls={dashifyString(props.title) + '-content'}
        id={dashifyString(props.title) + '-header'}
        classes={{
          root: classes.root + ' ' + (props.nested ? classes.nested : null),
          expandIcon: classes.expandIcon
        }}
      >
        {icon ? (
          <div className={props.iconNoBg ? classes.summaryIconNoBg : classes.summaryIcon}>
            {icon}
          </div>
        ) : null}

        <div className={classes.wrapper}>
          <Typography
            variant={props.type === 'target' ? 'body2' : 'h4'}
            component="h3"
            className={classes.title}
          >
            {props.title}
          </Typography>

          {props.subtitle ? (
            <Typography variant="caption" className={classes.subtitle}>
              {props.subtitle}
            </Typography>
          ) : null}

          {props.subtitleItems ? (
            <div className={classes.subtitleItems}>
              {props.subtitleItems.map(function(item, i) {
                const iconClasses = [classes.subtitleItemIcon]
                const textClasses = [classes.subtitleItemText]

                // Check if icon is set as active
                if (item.activeIcon) {
                  iconClasses.push(classes.subtitleItemIconActive)
                }

                // Check if icon is set as active
                if (item.activeText) {
                  textClasses.push(classes.subtitleItemTextActive)
                }

                return (
                  <div className={classes.subtitleItem} key={i}>
                    {item.icon ? <span className={iconClasses.join(' ')}>{item.icon}</span> : null}

                    {item.label ? (
                      <Typography variant="caption" className={textClasses.join(' ')}>
                        {item.label}
                      </Typography>
                    ) : null}
                  </div>
                )
              })}
            </div>
          ) : null}
        </div>
      </MUIExpansionPanelSummary>
    </>
  )
}
